"use client";

import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { PRODUITS } from "@/lib/diwline-data";
import { Crown } from "lucide-react";

export function Produits() {
  return (
    <section id="produits" className="relative bg-gradient-to-b from-royal via-bordeaux-deep/40 to-royal py-24 md:py-32" aria-label="La gamme prestige DIW'LINE">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="III"
          titre="La Gamme Prestige"
          intro="Cinq joyaux d'or liquide, façonnés dans nos huileries royales et scellés du sceau DIW'LINE — l'excellence sénégalaise offerte au monde entier."
        />

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PRODUITS.map((p, i) => (
            <Reveal
              key={p.nom}
              delay={i * 0.08}
              className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}
            >
              <article className="group relative h-full overflow-hidden rounded-sm border border-gold/20 bg-royal-brown transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_25px_70px_rgba(212,175,55,0.16)]">
                <div className="relative overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.nom}
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-108"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-royal-brown via-transparent to-transparent opacity-80" />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full border border-gold/50 bg-black/55 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-light backdrop-blur-sm">
                    <Crown className="h-3 w-3" aria-hidden />
                    {p.badge}
                  </span>
                </div>
                <div className="p-6">
                  <p className="font-elegant text-xs uppercase tracking-[0.25em] text-gold/80">
                    {p.essence}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-semibold text-cream group-hover:text-gold-light transition-colors">
                    {p.nom}
                  </h3>
                  <p className="mt-3 text-[13px] leading-relaxed text-cream/70">{p.description}</p>
                  <div className="mt-5 flex items-center justify-between border-t border-gold/15 pt-4">
                    <span className="text-[11px] uppercase tracking-[0.28em] text-cream/50">
                      Collection DIW&apos;LINE
                    </span>
                    <a
                      href="#contact"
                      className="text-[12px] font-semibold uppercase tracking-[0.2em] text-gold underline-offset-4 hover:underline"
                    >
                      Commander
                    </a>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}

          {/* Carte d'apparat — gamme complète */}
          <Reveal delay={0.4}>
            <article className="relative flex h-full min-h-[280px] flex-col justify-end overflow-hidden rounded-sm border border-gold/45 bg-gradient-to-b from-bordeaux to-bordeaux-deep p-7">
              <div className="bg-arabesque absolute inset-0" aria-hidden />
              <Crown className="relative h-9 w-9 text-gold" aria-hidden />
              <h3 className="relative mt-4 font-display text-2xl font-semibold text-gold-gradient animate-shimmer">
                Gamme complète d&apos;huiles & beurre prestige
              </h3>
              <p className="relative mt-3 text-[13px] leading-relaxed text-cream/80">
                Huiles de palme rouge, sésame doré, tournesol impérial et beurre de karité pur —
                toute la Maison réunie pour vos cuisines, vos rites et vos grands honneurs.
              </p>
              <a
                href="#oeuvres"
                className="relative mt-6 w-fit rounded-sm border border-gold/60 px-5 py-2.5 text-[12px] font-semibold uppercase tracking-[0.22em] text-gold transition-colors hover:bg-gold hover:text-royal"
              >
                Voir les œuvres
              </a>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
